var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.marginLeft
      ? 'display: inline;   margin-left: 5px;'
      : 'display: inline;   margin-righ: 5px;')},[(_vm.value === 'desc')?_c('i',{staticClass:"fa-light fa-arrow-down-wide-short"}):_vm._e(),(_vm.value === 'asc')?_c('i',{staticClass:"fa-regular fa-arrow-up-short-wide"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }